import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { AuthProvider } from 'services'
import { StoreProvider } from 'store'
import GlobalErrorModal from 'modals/GlobalErrorModal'

import Layout from 'pages/Layout'

import './index.css'
import CookiePolicyBanner from 'components/CookiePolicyBanner'
import AppRoutes from 'routes'

const root = createRoot(document.getElementById('root')!)

root.render(
  <StoreProvider>
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <AppRoutes />

          <CookiePolicyBanner />
        </Layout>

        <GlobalErrorModal />
      </AuthProvider>
    </BrowserRouter>
  </StoreProvider>
)
